import React, { useEffect, useState, ChangeEvent } from 'react';
//import jsreport from 'jsreport-browser-client';
//npm install jsreport-browser-client
import { PDFDownloadLink } from '@react-pdf/renderer';
import AvisoManifestacionPDF from '../../reports/Aviso';
import {
  Box,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  GridItem,
  Divider,
  Button,
  IconButton,
  Tooltip,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Collapse,
  Select,
  Input,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Wrap,
} from '@chakra-ui/react';
import {
  FiSend,
  FiPrinter,
  FiFileText,
  FiChevronDown,
  FiDownload,
  FiSettings,
  FiShare2,
  FiDollarSign,
  FiArrowDown,
  FiUser,
  FiUsers,
  FiFile,
} from 'react-icons/fi';
import {
  FaEdit,
  FaFileInvoice,
  FaFilePdf,
  FaSave,
  FaTrash,
} from 'react-icons/fa';
import HistorialPagos from '../Pagos/HistorialPagos'; // Importar HistorialPagos

import HistorialPagosAP from 'views/Pagos/HistorialPagosAgua';
import Facturar from 'views/Facturacion/FacturaModal';
import { Alert, FormControl, FormLabel } from 'react-bootstrap';
import HistorialModal from './HistorialdeCambios';
import fetchWithAuth from 'api/FetchInstance';
import PredioForm from '../Predio/PredioComponentes/informacion_general';
import ColindanciasForm from './PredioComponentes/colindancias';
import ConstruccionForm from './PredioComponentes/construccion';
import AvaluoForm from './PredioComponentes/avaluo';
import PropietariosForm from './PredioComponentes/propietarios';
//import FacturacionComponent from 'views/PagosGenericos/PagosModal';
import PagosGenericos from 'views/PagosGenericos/PagosModal';
import FacturacionComponent from 'views/Facturacion/PagoPredioManual';
import axios from 'axios';

interface PredioDetailProps {
  id: string;
}

interface cZonaValor {
  id: number;
  idZona: number;
  valorM2: string;
  habilitado: boolean;
}

interface cTenencia {
  id: number;
  descripcion: string;
  habilitado: boolean;
}
interface cRegimenPropiedad {
  id: number;
  descripcion: string;
  habilitado: boolean;
}

interface cEstadoFisico {
  id: number;
  descripcion: string;
  habilitado: boolean;
}

interface PropietarioData {
  id: string;
  nombre: string;
  primerApellido: string;
  segundoApellido?: string;
  rfc?: string;
  telefono?: string;
  esTitular: boolean;
}

interface Colindancia {
  id: string;
  idClaveCatastral: string;
  nombre: string;
  primerApellido: string;
  segundoApellido: string;
  orientacion: string;
  descripcion: string;
  longitud: string;
}

interface PredioData {
  idClaveCatastral: string;
  calle: string;
  numeroExterior: string;
  numeroInterior?: string;
  letra?: string;
  colonia: string;
  poblacion: string;
  paraje?: string;
  denominacion?: string;
  nivelesConstruidos: number;
  nivelesSubterraneos: number;
  fechaAlta: string;
  observaciones?: string;
  codigoPostal: number;
  ciudad: string;
  indiviso: string;
  frente: string;
  fondo: string;
  edificio: number;
  nivel: number;
  areaConsPrivativa: string;
  areaConsComun: string;
  areaConsTotal: string;
  areaTerrPrivativa: string;
  areaTerrComun: string;
  areaTerrTotal: string;
  areaTerrCarto: string;
  fechaActualizacion: string;
  usuario: string;
  origenMovimiento?: string;
  cuentaOrigen?: string;
  fechaOperacion?: string;
  cEstadoFisico: { descripcion: string };
  ClaveCatastral: {
    claveCatastralEstandar: string;
    Colindancias: [Colindancia];
    cTipoPredio: { descripcion: string };

    PropietarioPredio: [
      {
        Propietario: PropietarioData;
      },
    ];
  };
  cRegimenPropiedad: { descripcion: string };
  cTenencia: { descripcion: string };
  cZonaValor: { descripcion: string };
  cTipoPosesion: { descripcion: string };
  cUsoDestino: { descripcion: string };
  ServiciosInspeccion?: { idInspeccion: number };
}

const PredioDetail: React.FC<PredioDetailProps> = ({ id }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleConst, setIsVisibleConst] = useState(false);
  const [isVisibleAva, setIsVisibleAva] = useState(false);

  const [editable, setEditable] = useState(false);
  const cancelRef = React.useRef();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const [predio, setPredio] = useState<PredioData | null>(null);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPredio((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  //const estadoFisicoOptions = ['Bueno', 'Regular', 'Malo'];
  // const regimenPropiedadOptions = ['Privada', 'Pública', 'Ejidal'];
  // const tenenciaOptions = ['Propietario', 'Inquilino', 'Usufructuario'];

  const [estadoFisicoOptions, setestadoFisicoOptions] = useState<
    cEstadoFisico[]
  >([]);
  const [regimenPropiedadOptions, setregimenPropiedadOptions] = useState<
    cRegimenPropiedad[]
  >([]);
  const [tenenciaOptions, settenenciaOptions] = useState<cTenencia[]>([]);
  const [cZonaValor, setcZonaValor] = useState<cZonaValor[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenx, setIsModalOpenx] = useState(false);
  const { isOpen:isOpenx, onOpen:onOpenx, onClose:onClosex } = useDisclosure();
  const [password, setPassword] = useState('');
  // Función para manejar cambios en los campos seleccionables
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;

    if (predio) {
      setPredio({
        ...predio,
        [name]: { descripcion: value }, // Actualiza la descripción según el nombre del campo
      });
    }
  };

  const [searchTerm, setSearchTerm] = useState('');

  // Función para manejar los cambios en los campos del propietario
  const handlePropietarioInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    if (selectedPropietario) {
      setSelectedPropietario({
        ...selectedPropietario,
        [name]: name === 'esTitular' ? value === 'Sí' : value, // Maneja "esTitular" como booleano
      });
    }
  };
  const [propietarios, setPropietarios] = useState<PropietarioData[]>([
    // {
    //   id: '1',
    //   nombre: 'Alina',
    //   primerApellido: 'Santacruz',
    //   segundoApellido: 'Jimenez',
    //   rfc: 'ASJ123456789',
    //   telefono: '5551234567',
    //   esTitular: true,
    // },
    // {
    //   id: '2',
    //   nombre: 'Carlos',
    //   primerApellido: 'Perez',
    //   segundoApellido: 'Lopez',
    //   rfc: 'CPL987654321',
    //   telefono: '5559876543',
    //   esTitular: false,
    // },
  ]);

  const handleSearchChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      const response = await fetch(
        `http://52.91.130.91:5000/api/propietariospredios/${predio.idClaveCatastral}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            idPropietario: selectedPropietarioX,
          }),
        },
      );

      if (response.ok) {
        toast({
          title: 'Éxito',
          description: 'El propietario fue asignado correctamente al predio.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error('Error al asignar el propietario');
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Hubo un problema al asignar el propietario.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
      //onClose();
      isConfirmacionOnClose();
      onPropietarioModalClose();

    }
  };

  const handleMenuOnChange = (e: ChangeEvent<HTMLSelectElement>) => {
    // <----- here we assign event to ChangeEvent
    // Your logic here
    // handlePropietarioChange(e.target.value)
    //  toast({
    //   title: 'AVISO',
    //   description: 'CAMBIO REALIZADO.',
    //   status: 'info',
    //   duration: 3000,
    //   isClosable: true,
    // });
    // console.log(e.target.value); // Example: Log the value of the selected option
    setSelectedPropietarioX(e.target.value.toString());
    isConfirmacionOnOpen();
    //console.log(predio.idClaveCatastral);
    // app.use('http://52.91.130.91:5000/api/propietariospredios', propietarioPrediosRoutes);
  };
  // const filteredPropietarios = propietarios.filter((prop) =>
  //   `${prop.nombre} ${prop.primerApellido} ${prop.rfc}`
  //     .toLowerCase()
  //     .includes(searchTerm.toLowerCase()),
  // );

  const [selectedPropietarioX, setSelectedPropietarioX] = React.useState('');

  const [selectedPropietario, setSelectedPropietario] =
    useState<PropietarioData | null>(null);
  const [isPropietarioVisible, setIsPropietarioVisible] = useState(false);
  const [isEditingPosesion, setIsEditingPosesion] = useState(false);
  const [selectedPosesion, setSelectedPosesion] = useState(
    predio?.cTipoPosesion.descripcion || '',
  );
  const {
    isOpen: isHistorialPagosOpen,
    onOpen: onHistorialPagosOpen,
    onClose: onHistorialPagosClose,
  } = useDisclosure();

  const [predioData] = useState({
    claveCatastral: 'R-0996-36-01',
    localidad: 'San Juan Totolac',
    tipoPredio: 'Rústico',
    propietario: 'Horacio Jimenez Perez y Esp.',
    // Agrega otros datos necesarios según tu estructura de datos
  });

  const {
    isOpen: FacturarOpen,
    onOpen: onFacturarOpen,
    onClose: FacturarClose,
  } = useDisclosure();
  const {
    isOpen: isHistorialPagosAPOpenX,
    onOpen: onHistorialPagosAPOpenX,
    onClose: onHistorialPagosAPCloseX,
  } = useDisclosure();
  const {
    isOpen: isHistorialPagosAPOpen,
    onOpen: onHistorialPagosAPOpen,
    onClose: onHistorialPagosAPClose,
  } = useDisclosure();

  const tipoPosesionOptions = [
    'Propietario',
    'Inquilino',
    'Coproprietario',
    'Otros',
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isBajaOpen,
    onOpen: onBajaOpen,
    onClose: onBajaClose,
  } = useDisclosure();
  const {
    isOpen: isPropietarioModalOpen,
    onOpen: onPropietarioModalOpen,
    onClose: onPropietarioModalClose,
  } = useDisclosure();

  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const {
    isOpen: isConfirmacionOpen,
    onOpen: isConfirmacionOnOpen,
    onClose: isConfirmacionOnClose,
  } = useDisclosure();

  const fetchTransactions = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `http://52.91.130.91:5000/api/propietarios?page=1&pageSize=25&search=${searchQuery}`,
      );
      const data = await response.json();
      console.log(data.data);
      setPropietarios(data.data);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [searchQuery]);

  // useEffect(() => {
  //   const fetchPropietarios = async () => {
  //     try {
  //       const response = await fetch('http://52.91.130.91:5000/api/propietarios');
  //       const data = await response.json();
  //       setPropietarios(data);
  //     } catch (error) {
  //       console.error('Error al cargar propietarios:', error);
  //     }
  //   };

  //   if (isPropietarioModalOpen) {
  //     fetchPropietarios();
  //   }
  // }, [isPropietarioModalOpen]);

  const handleDelete = async () => {
    //alert(password)
    if (password === 'blink0') { // Cambia por la lógica de validación real
      try {
        if (id) {
          await axios.delete(`http://52.91.130.91:5000/api/predio/${predio.idClaveCatastral}`);
          toast({
            title: 'Éxito',
            description: 'El predio ha sido eliminado',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
          onClose(); // Cierra el modal después de la eliminación
        }
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo eliminar el predio.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } else {
      toast({
        title: 'Contraseña incorrecta',
        description: 'No se pudo eliminar el predio. Verifique la contraseña.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const fetchPredio = async () => {
      try {
        fetchTransactions();

        const response = await fetchWithAuth(
          `http://52.91.130.91:5000/api/predio/${id}`,
        );
        const data = await response.json();
        setPredio(data);
        setSelectedPropietario(
          data.ClaveCatastral.PropietarioPredio[0].Propietario,
        );

        const response1 = await fetch(
          `http://52.91.130.91:5000/api/cEstadoFisicoRoutes`,
        );
        const data1 = await response1.json();
        setestadoFisicoOptions(data1);

        const response2 = await fetch(
          `http://52.91.130.91:5000/api/cRegimenPropiedad`,
        );
        const data2 = await response2.json();
        setregimenPropiedadOptions(data2);

        const response3 = await fetch(
          `http://52.91.130.91:5000/api/cTenenciaRoutes`,
        );
        const data3 = await response3.json();
        settenenciaOptions(data3);

        const response4 = await fetch(
          `http://52.91.130.91:5000/api/cZonaValor/${data.ClaveCatastral.idMunicipio}`,
        );
        const data4 = await response4.json();
        setcZonaValor(data4);
      } catch (error) {
        console.error('Error al cargar los detalles del predio:', error);
      }
    };
    fetchPredio();
  }, [id]);

  if (!predio) return <Text>Cargando...</Text>;

  const handlePropietarioChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newPropietario = propietarios.find(
      (p) =>
        typeof p.id === 'number'
          ? p.id === parseInt(event.target.value, 10) // Si id es numérico
          : p.id === event.target.value, // Si id es string
    );

    if (newPropietario) setSelectedPropietario(newPropietario);
  };

  const handlePosesionSave = () => {
    if (predio) {
      setPredio({
        ...predio,
        cTipoPosesion: { descripcion: selectedPosesion },
      });
      setIsEditingPosesion(false);
    }
  };

  const handleEditToggle = () => {
    setEditable(!editable);
    if (editable) {
      // Aquí puedes añadir lógica para guardar los cambios
      console.log('Datos guardados:');
    }
  };

  return (
    <Box>
       
      {/* Barra de Herramientas */}
      <Wrap>
        {/* <Tooltip label="Solicitar Autorización">
          <Button colorScheme="teal" leftIcon={<FiFileText />} onClick={onOpen}>
            Solicitar Autorización
          </Button>
        </Tooltip> */}
        {/* <Tooltip label="Facturar">
          <IconButton
            colorScheme="blue"
            aria-label="Facturar"
            icon={<FaFileInvoice />}
            onClick={onFacturarOpen}
          />
        </Tooltip> */}
        <HistorialModal
          id={predio.idClaveCatastral}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />

        <Tooltip label={editable ? 'Guardar' : 'Editar'}>
          <IconButton
            aria-label={editable ? 'Guardar' : 'Editar'}
            icon={editable ? <FaSave /> : <FaEdit />}
            onClick={handleEditToggle}
            colorScheme={editable ? 'green' : 'blue'}
            mb={4}
          />
        </Tooltip>
        <Tooltip label="Eliminar">
          <IconButton
            colorScheme="red"
            aria-label="Eliminar"
            icon={<FaTrash />}
            onClick={onOpenx}
          />
        </Tooltip>

        <Menu>
          <MenuButton
            as={Button}
            colorScheme="orange"
            rightIcon={<FiChevronDown />}
          >
            Agua Potable
          </MenuButton>
          <MenuList>
            <MenuItem icon={<FiArrowDown />} onClick={onBajaOpen}>
              Solicitud de Baja
            </MenuItem>
            <MenuItem icon={<FiDollarSign />} onClick={onHistorialPagosAPOpen}>
              Pagos
            </MenuItem>
            {/* <MenuItem icon={<FiDownload />}>Historial de Propietarios</MenuItem> */}
          </MenuList>
        </Menu>
        <Menu>
          <MenuButton
            as={Button}
            colorScheme="orange"
            rightIcon={<FiChevronDown />}
          >
            Predial
          </MenuButton>
          <MenuList>
            <MenuItem icon={<FiUser />} onClick={onPropietarioModalOpen}>
              Cambio de Propietario
            </MenuItem>
            <MenuItem icon={<FiDollarSign />} onClick={onHistorialPagosOpen}>
              Pagos
            </MenuItem>
            <MenuItem
              icon={<FiUsers />}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              Historial de Propietarios
            </MenuItem>
            <MenuItem
              icon={<FaFilePdf />}
              onClick={() => {
                onHistorialPagosAPOpenX();
              }}
            >
             Generar Pago de Predio Manual
            </MenuItem>
            {/* <MenuItem
              icon={<FaFilePdf />}
              onClick={() => {
                onHistorialPagosAPOpenX();
              }}
            >
              Pago Generico
            </MenuItem> */}
            {/* <MenuItem icon={<FaFilePdf />}>
              <PDFDownloadLink
                document={<AvisoManifestacionPDF predio={predioData} />}
                fileName="AvisoManifestacion.pdf"
              >
                <Text> Descargar PDF </Text>
              </PDFDownloadLink>
            </MenuItem>
            <MenuItem icon={<FiFile />}>Generar Avaluo</MenuItem> */}
          </MenuList>
        </Menu>
        <Tooltip label="Configuración">
          <IconButton
            colorScheme="gray"
            aria-label="Configuración"
            icon={<FiSettings />}
          />
        </Tooltip>
        <Tooltip label="Compartir">
          <IconButton
            colorScheme="blue"
            aria-label="Compartir"
            icon={<FiShare2 />}
          />
        </Tooltip>
      </Wrap>
     
      <Modal isOpen={isOpenx} onClose={onClosex}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmar Eliminación</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
              <Text>Ingrese su contraseña para confirmar</Text>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Contraseña"
              />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={handleDelete}>
              Confirmar
            </Button>
            <Button variant="ghost" onClick={onClosex}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Modal para solicitud de baja AP */}
      <Modal isOpen={isBajaOpen} onClose={onBajaClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Solicitud de Baja</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={4}>
              La solicitud de baja de AP conlleva un proceso administrativo
              donde se debe validar toda la información del predio y el
              propietario. Por favor, confirme el trámite si desea proceder con
              la baja de AP.
            </Text>
            <Button
              colorScheme="blue"
              leftIcon={<FiPrinter />}
              onClick={() => window.print()}
            >
              Imprimir Solicitud
            </Button>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" mr={3} onClick={onBajaClose}>
              Confirmar Trámite
            </Button>
            <Button variant="ghost" onClick={onBajaClose}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

        {/* Modal para Generacion de Pagos */}
        <Modal
        isOpen={isHistorialPagosAPOpenX}
        onClose={onHistorialPagosAPCloseX}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <FacturacionComponent data={predio} idClaveCatastral={predio.idClaveCatastral} monto={0} pagoid=''
            
            onClose={onHistorialPagosAPCloseX} // Pasamos la función de cierre

            />
          </ModalBody>
          {/* <ModalFooter>
            <Button variant="ghost" onClick={onHistorialPagosAPCloseX}>
              Cerrar
            </Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>

      {/* Modal para Historial de Pagos */}
      <Modal
        isOpen={isHistorialPagosAPOpen}
        onClose={onHistorialPagosAPClose}
        size="3xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Historial de Pagos Agua Potable</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HistorialPagosAP idClaveCatastral={id} />
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onHistorialPagosAPClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para Historial de Pagos */}
      <Modal
        isOpen={isHistorialPagosOpen}
        onClose={onHistorialPagosClose}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Historial de Pagos Predio</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HistorialPagos
              idClaveCatastral={predio.ClaveCatastral.claveCatastralEstandar}
              idPredioSys={id}
              data={predio}
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onHistorialPagosClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isPropietarioModalOpen} onClose={onPropietarioModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cambiar de Propietario</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Buscar propietario..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              mb={4}
            />
            <AlertDialog
              isOpen={isConfirmacionOpen}
              leastDestructiveRef={cancelRef}
              onClose={isConfirmacionOnClose}
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    Confirmar Asignación
                  </AlertDialogHeader>

                  <AlertDialogBody>
                    ¿Estás seguro de que deseas asignar este propietario al
                    predio?
                  </AlertDialogBody>

                  <AlertDialogFooter>
                    {/* <Button ref={cancelRef} onClick={onClose}>
                      Cancelar
                    </Button> */}
                    <Button
                      colorScheme="red"
                      onClick={handleConfirm}
                      ml={3}
                      isLoading={isSubmitting}
                    >
                      Confirmar
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
            {/* Select dinámico */}
            <Select
              placeholder="Selecciona un propietario"
              onChange={handleMenuOnChange}
              value={''}
            >
              {isLoading ? (
                <option disabled>Cargando propietarios...</option>
              ) : (
                propietarios.map((propietario) => (
                  <option key={propietario.id} value={propietario.id}>
                    {`${propietario.id} ${propietario.nombre} ${propietario.primerApellido}  ${propietario.segundoApellido}`}
                  </option>
                ))
              )}
            </Select>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onPropietarioModalClose}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Divider my={6} />

      {/* Información General del Predio */}
      <Heading as="h3" size="md" color="teal.500" mb={4}>
        Información General del Predio:
      </Heading>
    
      {/* <informacion_general id={id}></informacion_general> */}
      <PredioForm id={id}></PredioForm>
      <Divider my={6} />
      {/* Información del Propietario */}
      <Heading
        as="h3"
        size="md"
        color="teal.500"
        mb={4}
        onClick={() => setIsPropietarioVisible(!isPropietarioVisible)}
        cursor="pointer"
      >
        Información del Propietario
      </Heading>
      <Collapse in={isPropietarioVisible} animateOpacity>
        <PropietariosForm
          idClaveCatastral={predio.idClaveCatastral}
        ></PropietariosForm>
      </Collapse>
      <Divider my={6} />
      <Heading
        as="h3"
        size="md"
        color="teal.500"
        mb={4}
        onClick={() => setIsVisible(!isVisible)}
        cursor="pointer"
      >
        Colindancias
      </Heading>
      <Collapse in={isVisible} animateOpacity>
        <ColindanciasForm
          idClaveCatastral={predio.idClaveCatastral}
        ></ColindanciasForm>
      </Collapse>
      <Divider my={6} />
      <Heading
        as="h3"
        size="md"
        color="teal.500"
        mb={4}
        onClick={() => setIsVisibleConst(!isVisibleConst)}
        cursor="pointer"
      >
        Construccion
      </Heading>
      <Collapse in={isVisibleConst} animateOpacity>
        <ConstruccionForm idClaveCatastral={Number(predio.idClaveCatastral)}></ConstruccionForm>
      </Collapse>
      <Divider my={6} />
      <Heading
        as="h3"
        size="md"
        color="teal.500"
        mb={4}
        onClick={() => setIsVisibleAva(!isVisibleAva)}
        cursor="pointer"
      >
        Avaluo y Manifestacion
      </Heading>
      <Collapse in={isVisibleAva} animateOpacity>
        <AvaluoForm id={predio.idClaveCatastral}></AvaluoForm>
      </Collapse>

      
    </Box>
    
  );
};

export default PredioDetail;
